import { render, staticRenderFns } from "./OrganizationSubscriptions.vue?vue&type=template&id=3b21e4ea"
import script from "./OrganizationSubscriptions.vue?vue&type=script&lang=js"
export * from "./OrganizationSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports